import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  constructor(public db: AngularFireDatabase) {
    this.db.database.app.auth().setPersistence('session');
  }
  fetchOffset(): Observable<number> {
    return this.db
      .object('.info/serverTimeOffset')
      .valueChanges()
      .pipe(first()) as Observable<number>;
  }
}
